import padStart from "./padStart";

export function isEpisodePlayable(freeEpisodes, tvSeasonNumber, tvSeasonEpisodeNumber) {
  const episodeCode = `S${padStart(tvSeasonNumber, 2, "0")}-E${padStart(tvSeasonEpisodeNumber, 3, "0")}`;
  return freeEpisodes.includes(episodeCode);
}

export function isFVODFreeToAir(tagsArr = []) {
  const freeToAirTag = tagsArr.find(tag => tag.tagTitle === "free-to-air");
  if (freeToAirTag) {
    return true;
  }
  return false;
}

export function isFreeEpisodeTag(tagsArr = []) {
  const freeToAirTag = tagsArr.find(tag => tag.tagScheme === "urn:peg:badge");
  if (freeToAirTag) {
    return freeToAirTag?.tagTitle;
  }
  return null;
}

export function removeHyphens(str) {
  return str.replace(/-/g, "");
}

export function parseSeasonAndEpisode(text) {
  // Use a regular expression to match the season and episode numbers
  const match = text.match(/S(\d+)-E(\d+)/);

  if (match) {
    // Extract the season and episode numbers from the matched groups
    const seasonNumber = parseInt(match[1], 10);
    const episodeNumber = parseInt(match[2], 10);

    return { seasonNumber, episodeNumber };
  } else {
    // If the text doesn't match the expected format, return null or handle the error accordingly
    return null;
  }
}

export function getFirstFreeEpisodeIndex(episodesList, freeEpisodes) {
  if (freeEpisodes && freeEpisodes.length > 0) {
    const freeEpisode = parseSeasonAndEpisode(freeEpisodes[0]);
    return findEpisodeIndex(episodesList, freeEpisode.seasonNumber, freeEpisode.episodeNumber);
  }
  return 0;
}

export function findEpisodeIndex(episodes, tvSeasonNumber, tvSeasonEpisodeNumber) {
  for (let i = 0; i < episodes.length; i++) {
    if (episodes[i].tvSeasonNumber === tvSeasonNumber && episodes[i].tvSeasonEpisodeNumber === tvSeasonEpisodeNumber) {
      return i; // Return the index of the matching object
    }
  }
  return 0; // Return -1 if no matching object is found
}

export function extractSeasonNumber(str) {
  const sIndex = str.indexOf("S"); // Find the index of 'S' in the string
  if (sIndex !== -1) {
    // If 'S' is found in the string
    const seasonSubstring = str.substring(sIndex + 1); // Get the substring after 'S'
    const seasonNumber = parseInt(seasonSubstring, 10); // Parse the substring to an integer
    if (!isNaN(seasonNumber)) {
      // Check if parsing was successful
      return seasonNumber; // Return the season number
    }
  }
  return null; // Return null if 'S' is not found or parsing fails
}
